<div class="mat-elevation-z8 customer-page">
    <h1 class="mat-align-center text-primary text-center">Logs do sistema 7Edu Financeiro (AFS)</h1>
    <mat-divider></mat-divider>

    <div class="w-100 item-center">
        <mat-form-field class="w-50" appearance="fill">
            <mat-label>Pesquisar....</mat-label>
            <input (keyup)="searchLogs($event)" matInput placeholder="digite..." />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <table class="table table-bordered table-hover">
        <thead class="thead-success">
            <tr>
                <th>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                        <label class="form-check-label" for="flexCheckChecked"> All </label>
                    </div>
                </th>
                <th>id</th>
                <th>level</th>
                <th>username</th>
                <th>logged</th>
                <th>siteName</th>
                <th>machineName</th>
                <th>logger</th>
                <th>message</th>
                <th>exception</th>
                <th>action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of dataSource; index as i">
                <td>
                    <div class="form-check">
                        <input
                            [checked]="data.selected"
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault" />
                        <label class="form-check-label" for="flexCheckDefault"> </label>
                    </div>
                </td>
                <td>{{ data.id }}</td>
                <td>{{ data.level }}</td>
                <td>{{ data.username }}</td>
                <td class="thLogged">{{ data.logged | date: 'dd-MM-yyyy hh:mm:ss' }}</td>
                <td>{{ data.siteName }}</td>
                <td>
                    <div class="thMachineName">
                        {{ data.machineName }}
                    </div>
                </td>
                <td class="thLogger">{{ data.logger }}</td>
                <td class="thMessage">{{ data.message }}</td>
                <td class="thException">{{ data.exception }}</td>
                <td>
                    <button mat-icon-button color="primary">
                        <mat-icon color="warn">close</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
